import { z } from 'zod';

import {
	type BettingSplitsESResult,
	type BettingSplitsMarket,
	type BettingSplitsResult,
} from '../types';

import { formatInTimeZoneWithLocale } from './formatInTimeZone';

const schemaSubevent = z.object({
	categoryGroupId: z.number(),
	categoryGroupName: z.string(),
	categoryId: z.number(),
	categoryName: z.string(),
	eventDisplayName: z.string(),
	eventId: z.number(),
	subeventEndTime: z.string(),
	subeventId: z.number(),
	subeventName: z.string(),
	subeventStartTime: z.string(),
	timestamp: z.string(),
});

export function extractSubevent(
	result: BettingSplitsESResult,
	{ TZ, locale }: { TZ: string; locale: string },
): BettingSplitsResult {
	const parsedSubevent = schemaSubevent.safeParse(result);

	if (!parsedSubevent.success) {
		throw new Error(
			`${JSON.stringify(parsedSubevent.error.flatten().fieldErrors)}`,
		);
	}

	const {
		categoryGroupId,
		categoryGroupName,
		categoryId,
		categoryName,
		eventDisplayName,
		eventId,
		subeventEndTime,
		subeventId,
		subeventName,
		subeventStartTime,
		timestamp,
	} = parsedSubevent.data;

	return {
		betTypeId: [] as number[],
		categoryGroupId,
		categoryGroupName,
		categoryId,
		categoryName,
		eventDisplayName,
		eventId,
		markets: [] as BettingSplitsMarket[],
		subeventId,
		subeventName,
		subeventEndTime,
		subeventStartDate: formatInTimeZoneWithLocale(
			subeventStartTime,
			'yyyy-MM-dd',
			TZ,
			locale,
		),
		subeventStartTime,
		timestamp,
	};
}
